import { DocumentNode, gql, useMutation } from '@apollo/client';
// Define the interface for vendor service input
export interface VendorServiceInput {
  claimUuid: string;
  vendorUuid: string;
  serviceUuid: string;
}

export const ADD_VENDOR_TO_CLAIM = gql`
  mutation AddVendorToContact($serviceInput: [ServiceFilterInput!]!) {
    addClaimVendorServices(serviceInput: $serviceInput)
  }
`;

export function useAddVendorToContactMutation() {
  const [addVendorToContactMutation, { loading, error, data }] = useMutation(
    ADD_VENDOR_TO_CLAIM as DocumentNode
  );

  const addVendorToContact = async (serviceInput: VendorServiceInput[]) => {
    const response = await addVendorToContactMutation({
      variables: {
        serviceInput,
      },
    });
    return response.data?.addClaimVendorServices;
  };

  return {
    addVendorToContact,
    loading,
    error,
    data,
  };
}
